const Counter1 = () => {
  return (
    <section className="counter-area pt-150 pb-105">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-4 col-md-6">
            <div className="counter-item">
              <h2 className="count">3DAYS</h2>
              <p>Average Saved / Week</p>
            </div>
          </div>
          <div className="col-lg-4 col-md-6">
            <div className="counter-item">
              <h2 className="count">400%</h2>
              <p>Average efficiency increase with AI Agents</p>
            </div>
          </div>
          <div className="col-lg-4 col-md-6">
            <div className="counter-item">
              <h2 className="count">480+</h2>
              <p>Powerful AI Business Tools</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default Counter1;
